import { useState } from "react";
import AddSubUserLink from "./AddSubUserLink.js";
import LoadingImageElement from "components/Elements/LoadingContainerElement/LoadingImageElement.tsx";
import AddSubUserInvitationLink from "./AddSubUserInvitationLink.js";
import { useContent } from "contexts/contentContext/contentContext.js";
import { useProfile } from "contexts/profileContext/profileContext.js";

import "./AddSubUserModal.scss";

const AddSubUserModal = () => {
  const { getTextByKey } = useContent();

  const [isInvitaionLink, setIsInvitationLink] = useState(true);
  const { loading, setLoading } = useProfile();

  return (
    <div className="add-user-to-organization">
      {loading ? (
        <div className="sub-user-loading">
          <LoadingImageElement />
        </div>
      ) : (
        <>
          <div className="title">{getTextByKey("add-sub-user-title")}</div>
          <div
            className={`modal-choose-header ${isInvitaionLink ? "active" : ""}`}
          >
            <div
              className={`invite-by-email ${isInvitaionLink ? "" : "active"}`}
              onClick={() => setIsInvitationLink(false)}
            >
              {getTextByKey("invite-by-email")}
            </div>
            <div
              className={`invite-by-link ${isInvitaionLink ? "active" : ""}`}
              onClick={() => setIsInvitationLink(true)}
            >
              {getTextByKey("invite-by-link")}
            </div>
          </div>
          {isInvitaionLink ? (
            <AddSubUserInvitationLink
              setLoading={setLoading}
              setIsInvitationLink={setIsInvitationLink}
            />
          ) : (
            <AddSubUserLink setLoading={setLoading} loading={loading} />
          )}
        </>
      )}
    </div>
  );
};

export default AddSubUserModal;
